import { Link } from 'react-router-dom'; // adapte selon ton router (Next.js → next/link, etc.)
export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 mb-6">
          <i className="ri-error-warning-line text-4xl text-red-500"></i>
        </div>

        <h1 className="text-6xl font-semibold text-gray-900 mb-4">404</h1>

        <p className="text-xl font-medium text-gray-700 mb-3">
          Page introuvable
        </p>

        <p className="text-base text-gray-500 mb-8">
          La ressource demandée n'existe pas ou n'est plus disponible.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            ← Accueil
          </Link>

          <button
            onClick={() => window.history.back()}
            className="px-5 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  );
}